import { render, staticRenderFns } from "./myFocus.vue?vue&type=template&id=36b07cae"
import script from "./myFocus.vue?vue&type=script&lang=js"
export * from "./myFocus.vue?vue&type=script&lang=js"
import style0 from "./myFocus.vue?vue&type=style&index=0&id=36b07cae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports